/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1SerieMutationRequest,
  PostApiV1SerieMutationResponse,
  PostApiV1Serie400,
  PostApiV1Serie401,
  PostApiV1Serie404,
  PostApiV1Serie500,
} from "../../types/serieRegistroController/PostApiV1Serie.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1Serie } from "../../clients/serieRegistroController/postApiV1Serie.ts";

export const postApiV1SerieMutationKey = () =>
  [{ url: "/api/v1/serie" }] as const;

export type PostApiV1SerieMutationKey = ReturnType<
  typeof postApiV1SerieMutationKey
>;

export function postApiV1SerieMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1SerieMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1SerieMutationKey();
  return mutationOptions<
    PostApiV1SerieMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Serie400
      | PostApiV1Serie401
      | PostApiV1Serie404
      | PostApiV1Serie500
    >,
    { data?: PostApiV1SerieMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1Serie(data, config);
    },
  });
}

/**
 * @description Cria uma nova série (multipart/form-data) com título/resumo no idioma corrente, turmas (quando não é geral) e imagem de capa opcional. **(Requer Authorization para autenticação)**
 * @summary Criar série (Requer Authorization para autenticação)
 * {@link /api/v1/serie}
 */
export function usePostApiV1Serie<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1SerieMutationResponse,
      ResponseErrorConfig<
        | PostApiV1Serie400
        | PostApiV1Serie401
        | PostApiV1Serie404
        | PostApiV1Serie500
      >,
      { data?: PostApiV1SerieMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiV1SerieMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1SerieMutationKey();

  const baseOptions = postApiV1SerieMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1SerieMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Serie400
      | PostApiV1Serie401
      | PostApiV1Serie404
      | PostApiV1Serie500
    >,
    { data?: PostApiV1SerieMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1SerieMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Serie400
      | PostApiV1Serie401
      | PostApiV1Serie404
      | PostApiV1Serie500
    >,
    { data?: PostApiV1SerieMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1SerieMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Serie400
      | PostApiV1Serie401
      | PostApiV1Serie404
      | PostApiV1Serie500
    >,
    { data?: PostApiV1SerieMutationRequest },
    TContext
  >;
}
